<template>
  <van-tabbar v-if="show" v-model="active" :border="true">
    <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon>
        <van-icon size="24" name="wap-home" />
      </template>
      <!-- <template #icon="props">
        <img :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'" :alt="$t('foorter.index')"
          v-show="show !== 0" />
        <img :src="props.active ? '/img/footer/indexed.jpg' : '/img/footer/index.jpg'" :alt="$t('foorter.index')"
          :class="$t('foorter.index')" style="height: 4rem" v-show="show === 0" />
      </template> -->
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon>
        <van-icon size="24" name="manager" />
      </template>
      <!-- <template #icon="props">
        <img :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'" :alt="$t('foorter.my')"
          v-show="show != 4" />
        <img :src="props.active ? '/img/footer/myed.jpg' : '/img/footer/my.jpg'" :alt="$t('foorter.my')"
          :class="$t('foorter.my')" style="height: 4rem" v-show="show == 4" />
      </template> -->
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {},
  watch: {
    $route(to) {
      console.log(to.name)
      if (to.name == "home") {
        this.active = 0;
        this.show = true;
      } else if (to.name == "game") {
        this.active = 1;
        this.show = true;
      } else if (to.name == "choose") {
        this.active = 2;
        this.show = true;
      } else if (to.name == "video") {
        this.active = 3;
        this.show = true;
      } else if (to.name == "mine") {
        // this.active = 4;
        this.active = 1;
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  created() {
    console.log(this.$route.name)
    if (this.$route.name == "home") {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == "game") {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == "choose") {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == "video") {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == "mine") {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  },
};
</script>

<style lang="less" scoped>
@tabbar-height: 100px;
@tabbar-img: 55px;

.van-tabbar {
  height: @tabbar-height;
  box-shadow: 0 0 0.13333rem 0 var(--color-core-blue-100, #0071dc);
}

.van-tabbar-item__icon img {
  height: @tabbar-img;
}

.van-tabbar-item {
  font-size: 20px;
}

.tui {
  width: 4rem;
  height: 4rem !important;
  margin-top: -1.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}

[class*="van-hairline"]::after {
  border: none !important;
}
</style>
